var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-landing-root grade-11-page min-h-screen bg-background"},[_c('welcome-navbar'),_c('grade-11-landing',{attrs:{"courses-route":_vm.coursesRoute,"whatsapp-url":_vm.whatsappUrl}}),_c('welcome-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }